import Component from "../abstracts/Component";
import { doAjax } from "../utils/ajaxUtil";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class WishlistComponent extends Component {
  get SELECTORS() {
    return {
      container: ".js-wishlist-dropdown",
      main: ".js-wishlist",
      item: ".wishlist .product-item",
      sizeLayer: ".js-sizes",
      addedMsg: ".item-added",
      icon: ".action.wishlist",
      remove: ".js-remove-wish",
      emptyWish: ".js-empty-wishlist-msg",
      qty: ".qty-items",
      wishlistLink: ".js-addtowishlist-link",
      nav_wishlist: ".wishlist-nav",
      qtyWishlist: ".wishlistCount",
      qtyWishlistTitle: ".wishlistCount-title",
      qtyWishlistMobile: ".wishlistCount-mobile",
      wishlistEmptySection: "[data-wishlist-empty]",
      wishlistFullSection: "[data-wishlist-full]",
      wishBtn: ".js-wishlist-cta"
    };
  }

  get CLASSES() {
    return {
      show: "show",
      active: "active",
      removing: "removing",
      icon_wishlist_on: "icon-wishlist-on",
      icon_wishlist_off: "icon-wishlist-off",
      addBtnClass: "js-addtowish",
      addedBtnClass: "js-added-wish",
      removeBtnClass: "js-remove-from-wish",
      added: "icon-wishlist-on",
      notAdded: "icon-wishlist"
    };
  }

  constructor() {
    super();

    this.timeout = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.item = $(this.SELECTORS.item);
    this.sizeLayer = $(this.SELECTORS.sizeLayer);
    this.addedMsg = $(this.SELECTORS.addedMsg);
    this.icon = $(this.SELECTORS.icon);
    this.remove = $(this.SELECTORS.remove);
    this.updated = false;
    this.qtyWishlist = $(this.SELECTORS.qtyWishlist);
    this.qtyWishlistMobile = $(this.SELECTORS.qtyWishlistMobile);
    this.qtyWishlistTitle = $(this.SELECTORS.qtyWishlistTitle);
    this.wishlistEmptySection = document.querySelector(
      this.SELECTORS.wishlistEmptySection
    );
    this.wishlistFullSection = document.querySelector(
      this.SELECTORS.wishlistFullSection
    );
    this.wishBtn = document.querySelectorAll(this.SELECTORS.wishBtn);
    this.wishlistLink = document.querySelector(this.SELECTORS.wishlistLink);
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000
    });
  }

  removeProduct(el) {
    let ctx = this;
    let $elem = $(el);
    let url = $elem.data("href");
    let code = $elem.data("code");
    $elem.attr("disabled", "disabled");

    if ($elem.has("disabled")) {
      $.ajax({
        url: url,
        dataType: "json",
        data: {
          productCode: code
        },
        type: "POST",
        success: function(resp) {
          // Aggiorna immediatamente tutti i bottoni wishlist con lo stesso productCode nella pagina
          let allWishlistButtons = document.querySelectorAll(
            `[data-code="${code}"], [data-product-code="${code}"], [data-wishlist-code="${code}"]`
          );
          allWishlistButtons.forEach(btn => {
            if (
              btn.classList.contains("js-addtowishlist") ||
              btn.classList.contains("js-wishlist-cta") ||
              btn.classList.contains("js-addtowish")
            ) {
              ctx.updateWishButton(btn, false);
            }
          });

          let qty =
            resp && resp.count !== undefined
              ? resp.count
              : parseInt(ctx.qtyWishlist.text()) - 1;
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, {
            elem: $elem,
            qty: qty
          });
        },
        error: function(xhr) {
          console.log(xhr);
          $elem.removeAttr("disabled");
        }
      });
    }
  }

  updateQtyWishlist(e) {
    let $elem = e;
    let ctx = this;
    let qtyNew = ctx.qtyWishlist.text() - 1;
    ctx.qtyWishlist.text(qtyNew);
    ctx.qtyWishlistMobile.text(qtyNew);
    let qtyNewTitle = ctx.qtyWishlistTitle;
    if (qtyNewTitle != null || typeof qtyNewTitle !== "undefined") {
      qtyNewTitle.text(" (" + qtyNew + ")");
    }
    $elem.removeAttr("disabled");
    ctx.dotVisibility(qtyNew);
    //update aria label
    if (ctx.wishlistLink) {
      ctx.wishlistLink.setAttribute(
        "aria-label",
        ctx.wishlistLink.dataset.ariaLabel + " " + qtyNew
      );
    }
  }

  appendHtml(html) {
    return new Promise((resolve, reject) => {
      try {
        this.main.html(html);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  updateWishlist() {
    let ctx = this;
    let $elem = ctx.main;

    return $.ajax({
      url: $elem.data("href"),
      dataType: "html",
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  addQtyWishlist() {
    let ctx = this;
    let qtyNew = parseInt(ctx.qtyWishlist.text()) + 1;
    ctx.qtyWishlist.text(qtyNew);
    ctx.qtyWishlistMobile.text(qtyNew);
    ctx.dotVisibility(qtyNew);
    if (ctx.wishlistLink) {
      ctx.wishlistLink.setAttribute(
        "aria-label",
        ctx.wishlistLink.dataset.ariaLabel + " " + qtyNew
      );
    }
  }

  dotVisibility(qty) {
    if (qty == null || typeof qty == "undefined") {
      qty = this.qtyWishlist.text();
    }
    this.qtyWishlist.attr("data-wlqty", qty);
  }

  updateWishlistCounter() {
    let ctx = this;

    let contextPath = document
      .getElementsByTagName("HTML")[0]
      .getAttribute("data-context");
    let wishlistUrl = contextPath + "/wishlist";

    $.ajax({
      url: wishlistUrl,
      type: "GET",
      success: function(response) {
        let $response = $(response);
        let count =
          $response.find(".js-qty-wishlist").text() ||
          $response.find(".qty-items").text() ||
          $response.find("[data-wlqty]").attr("data-wlqty") ||
          0;

        ctx.qtyWishlist.text(count);
        ctx.qtyWishlistMobile.text(count);
        ctx.dotVisibility(count);

        if (ctx.qtyWishlistTitle) {
          ctx.qtyWishlistTitle.text(" (" + count + ")");
        }
      },
      error: function() {
        ctx.dotVisibility();
      }
    });
  }

  wishlistCheckAjax(code) {
    return new Promise((resolve, reject) => {
      let data = {};
      data[code] = code;
      //
      let contextPath = document
        .getElementsByTagName("HTML")[0]
        .getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: code
        },
        success: function(result) {
          // resolve
          resolve(result);
        }
      });
    });
  }

  updateWishButton(btn, disable) {
    // check
    if (btn == null) return false;

    const labelAdded = btn.dataset.labelAdd;
    const labelRemove = btn.dataset.labelRemove;

    if (disable == true) {
      btn.classList.remove(this.CLASSES.addBtnClass);
      btn.classList.remove("js-addtowish"); // Rimuove la classe CSS per stato vuoto
      btn.classList.add(this.CLASSES.addedBtnClass);
      btn.classList.add("js-added-wish"); // Aggiunge la classe CSS per stato pieno
      btn.classList.add(this.CLASSES.removeBtnClass);
      btn.setAttribute("aria-label", labelRemove);
    } else {
      btn.classList.add(this.CLASSES.addBtnClass);
      btn.classList.add("js-addtowish"); // Aggiunge la classe CSS per stato vuoto
      btn.classList.remove(this.CLASSES.addedBtnClass);
      btn.classList.remove("js-added-wish"); // Rimuove la classe CSS per stato pieno
      btn.classList.remove(this.CLASSES.removeBtnClass);
      btn.setAttribute("aria-label", labelAdded);
    }

    btn.disabled = false;
  }

  selectedSize(target) {
    const ctx = this;
    const parent = $(target)
      .parent()
      .parent();
    let sizeSelected;
    let sizes = parent.siblings(ctx.SELECTORS.sizesForm)[0];
    if (typeof sizes === "undefined") {
      sizes = parent.parent().siblings(ctx.SELECTORS.sizesForm)[0];
    }
    if ($(sizes).find(".c-pdp-s__select-size").length !== 0) {
      sizeSelected = $(sizes)
        .find(".c-pdp-s__item.selected")
        .data("productCode");
    } else {
      sizeSelected = $(target).data("code");
    }
    return sizeSelected;
  }

  listenBtnWish(btns) {
    // global
    let ctx = this;
    // if not passed
    if (typeof btns == "undefined") btns = this.wishBtn;
    //
    if (btns != null) {
      btns.forEach(btn => {
        btn.addEventListener("click", elem => {
          // no default action
          elem.stopPropagation();
          // in base of button class
          if (btn.classList.contains(ctx.CLASSES.addBtnClass)) {
            // adding
            let url = btn.getAttribute("data-wish-add-url");
            ctx.addToWishlist(btn, url);
          } else {
            // removing
            let url = btn.getAttribute("data-wish-remove-url");
            ctx.removeToWishlist(btn, url);
          }
        });
      });
    }
  }

  addToWishlist(elem, url) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    elem.disabled = true;
    const labelAdded = elem.dataset.labelAdded;
    // ajax
    doAjax({
      url: url,
      data: {
        code: code
      },
      dataType: "html",
      success: function(resp) {
        ctx.log("added to wishlist", code);
        // n of items on wishlist
        let qty = resp;

        let allWishlistButtons = document.querySelectorAll(
          `[data-code="${code}"], [data-product-code="${code}"], [data-wishlist-code="${code}"]`
        );
        allWishlistButtons.forEach(btn => {
          if (
            btn.classList.contains("js-addtowishlist") ||
            btn.classList.contains("js-wishlist-cta") ||
            btn.classList.contains("js-addtowish")
          ) {
            ctx.updateWishButton(btn, true);
            ctx.liveRegion.sayMessage(labelAdded);
            btn.focus();
          }
        });

        // event
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, {
          elem: elem,
          qty: qty
        });
      },
      error: function(xhr) {
        elem.disabled = false;
      },
      complete: function() {
        // Assicura che il bottone sia sempre riabilitato alla fine
        elem.disabled = false;
      }
    });
  }

  removeToWishlist(elem, url) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    elem.disabled = true;
    const labelRemoved = elem.dataset.labelRemoved;

    ctx.updateWishButton(elem, false);

    // ajax
    doAjax({
      url: url,
      dataType: "json",
      data: {
        productCode: code
      },
      type: "POST",
      success: function(resp) {
        // n of items on wishlist
        let qty = resp.count;

        let allWishlistButtons = document.querySelectorAll(
          `[data-code="${code}"], [data-product-code="${code}"], [data-wishlist-code="${code}"]`
        );
        allWishlistButtons.forEach(btn => {
          if (
            btn.classList.contains("js-addtowishlist") ||
            btn.classList.contains("js-wishlist-cta") ||
            btn.classList.contains("js-addtowish")
          ) {
            ctx.updateWishButton(btn, false);
            ctx.liveRegion.sayMessage(labelRemoved);
            btn.focus();
          }
        });

        // launch event
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, {
          elem: elem,
          qty: qty
        });
      },
      error: function(xhr) {
        ctx.updateWishButton(elem, true);
        elem.disabled = false;
      },
      complete: function() {
        // Assicura che il bottone sia sempre riabilitato alla fine
        elem.disabled = false;
      }
    });
  }

  bindEvents() {
    let ctx = this;

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtocart,
      ({ event, payload }) => {
        //Remove from miniwishlist when selecting a size in miniwishlist
        let fromMiniWislist = $(payload.button).data("from-wishlist");
        ctx.dotVisibility();
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, e => {
      let $elem = $(e.payload);
      let code = $elem.data("code");
      $elem.attr("disabled", "disabled");

      let url = $elem.data("href");
      this.originalFocus = e.payload;

      if ($elem.has("disabled")) {
        $.ajax({
          url: url,
          data: {
            code: $elem.data("code")
          },
          dataType: "html",
          success: function(resp) {
            let qty = resp;
            let code = $elem.data("code");

            let allWishlistButtons = document.querySelectorAll(
              `[data-code="${code}"], [data-product-code="${code}"], [data-wishlist-code="${code}"]`
            );
            allWishlistButtons.forEach(btn => {
              if (
                btn.classList.contains("js-addtowishlist") ||
                btn.classList.contains("js-wishlist-cta") ||
                btn.classList.contains("js-addtowish")
              ) {
                ctx.updateWishButton(btn, true);
              }
            });

            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, {
              elem: $elem,
              qty: qty
            });
            $(ctx.SELECTORS.qty).text(qty);
            ctx.dotVisibility(qty);
          },
          error: function(xhr) {}
        }).always(() => {
          $elem.removeAttr("disabled");
        });
      }
    });

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.sizechanged,
      ({ event, payload }) => {
        // search the btn with the base product code
        let btnWish =
          document.querySelector(
            '[data-wishlist-code="' +
              payload.button.offsetParent.dataset.productCode +
              '"]'
          ) ?? null;

        if (btnWish) {
          let sendRequest = payload.button.dataset.productCode;

          // put in the button the size code
          btnWish.dataset.code = sendRequest;
          //btnWish.dataset.wishlistCode = sendRequest;

          // check size on size seleect
          // go promise
          this.wishlistCheckAjax(sendRequest).then(result => {
            // result
            if (result === "true") {
              // if is in WL i disable the button
              this.updateWishButton(btnWish, true);
            } else {
              // if not i enable it
              this.updateWishButton(btnWish, false);
            }
          });
        }
      }
    );

    this.$on(
      this.$customEvents.PRODUCT_EVENTS.addedtowish,
      ({ event, payload }) => {
        if (payload.qty != null) {
          this.qtyWishlist.text(payload.qty);
          this.qtyWishlistMobile.text(payload.qty);
          this.dotVisibility(payload.qty);
        }
        this.updateWishButton(payload.elem, true);
        if (this.wishlistLink) {
          this.wishlistLink.setAttribute(
            "aria-label",
            this.wishlistLink.dataset.ariaLabel + " " + payload.qty
          );
        }
      }
    );

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, e => {
      let ctx = this;
      let $elem = $(e.payload.elem || e.payload);
      let code = String($elem.data("code"));
      let $qty = e?.payload?.qty;
      const deletedLabel = e.payload.elem.dataset.labelRemoved;

      let item = $(`div[data-code="${code}"]`);
      let isWishlistPage = item.length > 0 && item.hasClass("product-item");

      if (isWishlistPage) {
        if ($qty > 0) {
          if (ctx.wishlistFullSection.classList.contains("hidden")) {
            ctx.wishlistFullSection.classList.remove("hidden");
            ctx.wishlistEmptySection.classList.add("hidden");
          }
        } else {
          if (ctx.wishlistEmptySection.classList.contains("hidden")) {
            ctx.wishlistEmptySection.classList.remove("hidden");
            ctx.wishlistFullSection.classList.add("hidden");
          }
        }

        item.addClass(ctx.CLASSES.removing);
        if ($qty != null) {
          ctx.qtyWishlist.text($qty);
          ctx.qtyWishlistMobile.text($qty);
          let qtyNewTitle = ctx.qtyWishlistTitle;
          if (qtyNewTitle != null || typeof qtyNewTitle !== "undefined") {
            qtyNewTitle.text(" (" + $qty + ")");
          }
          ctx.dotVisibility($qty);
          if (this.wishlistLink) {
            this.wishlistLink.setAttribute(
              "aria-label",
              this.wishlistLink.dataset.ariaLabel + " " + $qty
            );
          }
        }
        $elem.removeAttr("disabled");

        let productCode = code;
        let allWishlistButtons = document.querySelectorAll(
          `[data-code="${productCode}"], [data-product-code="${productCode}"]`
        );
        allWishlistButtons.forEach(btn => {
          if (
            btn.classList.contains("js-addtowishlist") ||
            btn.classList.contains("js-wishlist-cta")
          ) {
            ctx.updateWishButton(btn, false);
          }
        });

        setTimeout(function() {
          item.remove();
          ctx.liveRegion.sayMessage(deletedLabel);
        }, 800);
      } else {
        this.updateWishlist().always(res => {
          this.appendHtml(res).then(() => {
            if ($qty != null) {
              ctx.qtyWishlist.text($qty);
              ctx.qtyWishlistMobile.text($qty);
              let qtyNewTitle = ctx.qtyWishlistTitle;
              if (qtyNewTitle != null || typeof qtyNewTitle !== "undefined") {
                qtyNewTitle.text(" (" + $qty + ")");
              }
              ctx.dotVisibility($qty);
            }
            $elem.removeAttr("disabled");

            let productCode = code;
            let allWishlistButtons = document.querySelectorAll(
              `[data-code="${productCode}"], [data-product-code="${productCode}"]`
            );
            allWishlistButtons.forEach(btn => {
              if (
                btn.classList.contains("js-addtowishlist") ||
                btn.classList.contains("js-wishlist-cta")
              ) {
                ctx.updateWishButton(btn, false);
              }
            });
          });
        });
      }
    });

    $("body")
      .off("click.wishlist")
      .on("click.wishlist", ctx.SELECTORS.remove, function() {
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwish, this);
      });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, e => {
      let $elem = $(e.payload);

      if ($elem.attr("data-wish-remove-url")) {
        let url = $elem.attr("data-wish-remove-url");
        this.removeToWishlist(e.payload, url);
      } else {
        this.removeProduct(e.payload);
      }
    });

    this.dotVisibility();
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();

    this.listenBtnWish();
  }
}
